<template functional>
    <div
        class="vf-spinning-loader vf-icon"
        :class="
            `vf-icon-${props.size} ${data.staticClass} vf-spinning-loader--${props.palette}`
        "
        v-bind="data.attrs"
    />
</template>

<script>
import { PALETTES } from 'design-assets/constants/palettes.js';

const VALID_PALETTES = [ PALETTES.ACCENT, PALETTES.NONE ];

export default {
    name: 'VfSpinningLoader',
    props: {
        size: {
            type: String,
            default: 'small',
        },
        palette: {
            type: String,
            validator(palette) {
                return VALID_PALETTES.includes(palette);
            },
            default: PALETTES.NONE,
        },
    },
};
</script>

<style lang="scss">
@import '../../../css/variables/module';

.vf-spinning-loader {
    display: inline-block;
    border: 1px solid currentcolor;
    border-bottom-style: hidden;
    border-radius: 50%;
    animation-name: spin;
    animation-duration: 1000ms;
    animation-timing-function: linear;
    animation-iteration-count: infinite;

    &--accent {
        @include var(border-color, 'accent-color');
    }
}
</style>
